import { render } from "./button-toggle.vue?vue&type=template&id=00c7630d"
import script from "./button-toggle.vue?vue&type=script&lang=js"
export * from "./button-toggle.vue?vue&type=script&lang=js"

import "./button-toggle.vue?vue&type=style&index=0&id=00c7630d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__